import React from 'react';
import logoSrc from '../../assets/images/FBTLogo.svg';

const LOGO_WIDTH = 106;
const LOGO_HEIGHT = 48;

export interface CompanyLogoProps {
  width?: number;
  height?: number;
  alt?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({
  width,
  height = LOGO_HEIGHT,
  alt = 'FalconBrick',
}) => (
  <img
    src={logoSrc}
    alt={alt}
    width={width}
    height={height}
    style={{
      display: 'block',
      width: width ?? 'auto',
      height,
      objectFit: 'contain',
    }}
  />
);

export default CompanyLogo;
